import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Badge } from "../components/ui/badge";
import { Building2, User, ShieldCheck } from "lucide-react";
import { useToast } from "../hooks/use-toast";

export default function Settings() {
  const { session } = useAuth();
  const { toast } = useToast();
  const [org, setOrg] = useState(session?.organization?.name || "");
  const [name, setName] = useState(session?.user?.name || "");

  return (
    <div className="pt-2 pb-6 animate-fade-up max-w-3xl">
      <h1 className="font-display font-extrabold text-2xl sm:text-3xl text-brand-navy mb-1">Settings</h1>
      <p className="text-slate-500 mb-8">Manage your organisation and account.</p>

      <div className="bg-white rounded-2xl border border-slate-100 p-6 mb-6">
        <div className="flex items-center gap-3 mb-5"><div className="w-10 h-10 rounded-xl bg-brand-light text-brand-blue flex items-center justify-center"><Building2 className="w-5 h-5" /></div><h3 className="font-display font-bold text-lg text-brand-navy">Organisation</h3></div>
        <div className="grid sm:grid-cols-2 gap-4">
          <div className="grid gap-1.5"><Label className="text-xs text-slate-500">Organisation name</Label><Input value={org} onChange={(e) => setOrg(e.target.value)} /></div>
          <div className="grid gap-1.5"><Label className="text-xs text-slate-500">Country</Label><Input value="Botswana" disabled /></div>
          <div className="grid gap-1.5"><Label className="text-xs text-slate-500">Plan</Label><div className="flex items-center h-10"><Badge className="bg-brand-light text-brand-blue hover:bg-brand-light">{session?.organization?.plan}</Badge></div></div>
          <div className="grid gap-1.5"><Label className="text-xs text-slate-500">Organisation ID</Label><Input value={session?.organization?.id} disabled className="font-mono text-xs" /></div>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 p-6 mb-6">
        <div className="flex items-center gap-3 mb-5"><div className="w-10 h-10 rounded-xl bg-brand-light text-brand-blue flex items-center justify-center"><User className="w-5 h-5" /></div><h3 className="font-display font-bold text-lg text-brand-navy">Your profile</h3></div>
        <div className="grid sm:grid-cols-2 gap-4">
          <div className="grid gap-1.5"><Label className="text-xs text-slate-500">Full name</Label><Input value={name} onChange={(e) => setName(e.target.value)} /></div>
          <div className="grid gap-1.5"><Label className="text-xs text-slate-500">Email</Label><Input value={session?.user?.email} disabled /></div>
          <div className="grid gap-1.5"><Label className="text-xs text-slate-500">Role</Label><div className="flex items-center gap-2 h-10 text-sm text-brand-navy"><ShieldCheck className="w-4 h-4 text-brand-blue" /> {session?.user?.role}</div></div>
        </div>
      </div>

      <Button onClick={() => toast({ title: "Settings saved", description: "Your changes have been saved (demo)." })} className="bg-brand-blue hover:bg-brand-bluedark text-white rounded-lg h-11 px-6">Save changes</Button>
    </div>
  );
}
